import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@Sage/hoi-poi-ui';
import ImplementationSwitch from './implementation-switch';
import ProfileHolder from './profile-holder';
import { t } from 'utils/getLiteral';
import './styles.scss';

/**
 * Header component.
 */
const Header = ({ title = '', history }) => (
    <div className="header container-fluid">
        <div className="row">
            <div className="col-4 header-left">
                <Text type="h4" color="neutral900">
                    {t(title)}
                </Text>
            </div>
            <div className="col-4 header-center">
                <ImplementationSwitch history={history} />
            </div>
            <div className="col-4 header-right">
                <ProfileHolder />
            </div>
        </div>
    </div>
);

Header.propTypes = {
    title: PropTypes.string,
};

export default Header;
